import {useCallback, useState} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
import {addNewTag} from '../../api/EcaServices';
import {useToast} from '../../contexts/toastContext/ToastContext';
import {t} from 'i18next';

interface IAddNewTagBody {
  value: string;
  displayOrder: number;
}

export const useAddNewTag = () => {
  const {showToast} = useToast();
  const clientId = useSelector(
    (state: RootState) => state.selectedClient
  ).clientId;

  const projectId = useSelector((state: RootState) => state.reports).projectId;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const addTag = useCallback(
    async (
      tag: IAddNewTagBody,
      tagFieldId: string,
      onSuccess?: (newTagId: string) => void
    ) => {
      try {
        setIsLoading((prev) => !prev);
        const params = `?clientId=${clientId}&projectId=${projectId}`;

        const {
          data: {data},
        } = await addNewTag(params, tagFieldId, [tag]);
        onSuccess && onSuccess(data);
      } catch {
        // error intentionally ignored, handled via toast to notify the user
        showToast(
          t('ecaDocList.bulkTagging.addNewTag.apiError'),
          'error',
          5000,
          'center',
          'bottom'
        );
      } finally {
        setIsLoading((prev) => !prev);
      }
    },
    [clientId, projectId, showToast]
  );

  return {
    addTag,
    isLoading,
  };
};
